import React, { useEffect, useMemo, useRef, useState } from 'react'
import useAuthForQr from '../../customHooks/useAuthForQr'
import "../PostCheckInRequest/FoodRequest/FoodRequest.css";
import FoodTypeMark from '../PostCheckInRequest/FoodRequest/FoodTypeMark';
import {
  DIET_FILTERS,
  titleCase,
  orderedTypes,
} from '../../common/foodMenu';
import PrevIcon from "../../assets/icons/coloredPrev.svg";
import Prev from "../../assets/icons/PrevIcon.svg";
import SearchIcon from "../../assets/icons/Search.svg";
import CloseIcon from "../../assets/icons/closeIcon.svg"
import Photo from "../../assets/photo.png";
import { useNavigate,useLocation, useParams } from 'react-router-dom';
import FoodCard from '../PostCheckInRequest/FoodRequest/FoodCard/FoodCard';
import axiosInstance from '../../axiosInstance/axiosInstance';
import PageLoader from '../components/PageLoader/PageLoader';
import axios from 'axios';
import { toast } from 'react-toastify';
import MenuModal from '../PostCheckInRequest/FoodRequest/MenuModal/MenuModal';
import menuIcon from "../../assets/icons/menu.png"
import PromoSection from '../PostCheckInRequest/FoodSummary/PromoSection';
import { taxOnLines } from '../../common/gst';
import { formatMoney } from '../../common/money';

export default function RestaurantDining() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const { hotelId, tableId } = useParams();


  // const menu = location.state?.menu || [];
  const foodCartItems = location.state?.foodCart || [];

  // Searching
  const [isSearching, setIsSearching] = useState(false); // State to toggle between h2 and input
  
  const [isLoading,setIsLoading] = useState(false);
  
  // UseState
  // const [filterModal,setFilterModal] = useState(false);
  const [foodCart,setFoodCart] = useState([]);
  const [totalPrice,setTotalPrice] = useState(0);
  const [quantity,setQuantity] = useState(0);
  const [search,setSearch] = useState("");
  const [diets,setDiets] = useState([]);
  const [onlyBestseller,setOnlyBestseller] = useState(false);
  const [onlyChefSpecial,setOnlyChefSpecial] = useState(false);
  const [activeType,setActiveType] = useState("");
  const groupRefs = useRef({});
  const [menu,setMenu] = useState([]);
  const [confirmPrice,setConfirmPrice] = useState(false);

  const userId = localStorage.getItem("user_id");

  // Applied promo (offer object | null) + the discount amount in ₹
  const [appliedPromo,setAppliedPromo] = useState(null);
  const [discountAmount,setDiscountAmount] = useState(0);
  const discountedTotal = Math.max(0, (Number(totalPrice) || 0) - discountAmount);

  // Same basis the backend uses: GST is charged on the discounted amount, per item rate.
  const taxTotal = taxOnLines(
    foodCart.map((item) => ({
      amount: (Number(item.price) || 0) * item.quantity,
      gst_percentage: item.gst_percentage,
    })),
    Number(totalPrice) || 0,
    discountAmount,
  );
  const payableTotal = discountedTotal + taxTotal;

  const handleApplyPromo = (offer, discount) => {
    setAppliedPromo(offer);
    setDiscountAmount(discount);
  };
  const handleRemovePromo = () => {
    setAppliedPromo(null);
    setDiscountAmount(0);
  };

  // Fetch Menu Items
  useEffect(()=>{
    const fetchMenu = async()=>{
      try{
        setIsLoading(true);
       
        const response =  await axiosInstance.get(`/api/v1/hotels/${hotelId}/restaurant/menu-items`);
        // console.log("Menu Items :",response?.data?.data || []);
        const data = response?.data?.data || [];
        setMenu(data);

      }catch(error){
        console.log(error);
      }
      finally{
        setIsLoading(false);

      }
    }
    fetchMenu();
  },[]);

 


  // Set FoodCartItems from location
  useEffect(() => {
      if (foodCartItems.length > 0) {
          setFoodCart(foodCartItems);
      }
  }, [foodCartItems]); // Notice: foodCartItems is used directly here


  // For Total Price
  useEffect(() => {
      const totalPrice = ()=>{
          let price = 0;
          foodCart.map((food)=>(
              price +=food.price*food.quantity
          ));
          return price;
      };
      let price = totalPrice();
      setTotalPrice(price);

  },[foodCart])


  // For Total Quantity
  useEffect(()=>{

      const totalQuantity = ()=>{
          let qty = 0;
          foodCart.map((food)=>(
              qty+=food.quantity
          ));
          return qty;
      }
      let totalqty = totalQuantity();
      // console.log("total Qty :",totalqty);
      setQuantity(totalqty);
  },[foodCart]);



  // Confirm
  const handleConfirm = ()=> {
    try{
      setConfirmPrice(true);
    }catch(error){
      console.log(error);
    }
  }

  // Move Back
  const moveBack = ()=>{
    try{
      setConfirmPrice(false);
    }catch(error){
      console.log(error);
    }
  }

  // Meal-time tabs, filters and grouping all behave exactly as the in-room
  // dining menu does — see FoodRequest.jsx.
  const types = useMemo(() => orderedTypes(menu), [menu]);

  useEffect(() => {
    if (types.length > 0 && !types.includes(activeType)) {
      setActiveType(types[0]);
    }
  }, [types, activeType]);

  const toggleDiet = (key) => {
    setDiets(prev => prev.includes(key) ? prev.filter(d => d !== key) : [...prev, key]);
  };

  const clearFilters = () => {
    setDiets([]);
    setOnlyBestseller(false);
    setOnlyChefSpecial(false);
    setSearch("");
  };

  const filtersApplied =
    diets.length > 0 || onlyBestseller || onlyChefSpecial || search !== "";

  const matchesFilters = (food) => {
    if (diets.length > 0 && !diets.includes(food.food_type)) {
      return false;
    }
    if (onlyBestseller && !food.is_bestseller) {
      return false;
    }
    if (onlyChefSpecial && !food.is_chef_recommended) {
      return false;
    }
    if (search !== "" && !food.name?.toLowerCase().includes(search.toLowerCase())) {
      return false;
    }
    return true;
  };

  // Searching looks across the whole menu; browsing stays inside the cuisine
  // tab the guest picked.
  const visibleMenu = (menu || []).filter(food =>
    matchesFilters(food) && (search !== "" || (food.type || 'Other') === activeType)
  );

  const groups = useMemo(() => {
    const byType = {};
    visibleMenu.forEach(food => {
      const type = food.type || 'Other';
      if (!byType[type]) {
        byType[type] = [];
      }
      byType[type].push(food);
    });
    return Object.entries(byType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, activeType, search, diets, onlyBestseller, onlyChefSpecial]);

  const handleSearchClick = () => {
    setIsSearching(true);
  };

  const handleCloseSearch = () => {
    setSearch("");
    setIsSearching(false);
  };

  // Handle Change function
  const handleChangeComment = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
 

  const [formData,setFormData] = useState({
    comments : ""
  });


  useAuthForQr(hotelId, tableId);

  const handleSubmit = async()=>{
    try{
      setIsLoading(true);
      const payload = {
        additional_comments : formData.comments,
        food_items : foodCart,
        promo_code : appliedPromo?.code || ""
      }
      // console.log("Payload :",payload);
      // return;
      const response = await axiosInstance.post(`/api/v1/users/${userId}/hotels/${hotelId}/tables/${tableId}/restaurant-food-request`,payload);
      // Prefer the server-authoritative discount for the confirmation message.
      const savedAmount = response?.data?.discount_amount ?? (appliedPromo ? discountAmount : 0);
      if (savedAmount > 0) {
        toast.success(`Request Sent! You saved ₹${formatMoney(savedAmount)} 🎉`);
      } else {
        toast.success("Request Sent Successfully");
      }
      navigate("/bookings",{state : {activeRequests : "requests"}})
    }catch(error){
      console.log(error);
      toast.error(error?.response?.data?.message || "Some Error Occured");
    }
    finally{
      setIsLoading(false);
    }
  }


    const [menuModal,setMenuModal] =  useState(false);
    const scrollToType = (type) => {
      const match = types.find(
        candidate => candidate?.toLowerCase() === String(type || "").toLowerCase()
      );
      if (match) {
        setActiveType(match);
        setSearch("");
        setIsSearching(false);
      }

      setTimeout(() => {
        // The browse sheet upper-cases the type it hands back, so the group is
        // matched on case-insensitively rather than by exact key.
        const key = Object.keys(groupRefs.current).find(
          candidate => candidate?.toLowerCase() === String(type || "").toLowerCase()
        );
        const target = key ? groupRefs.current[key] : null;
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    };


  return (
    <>
      {isLoading && <PageLoader/>}

      {
        !confirmPrice && 
        <div className="foodRequest">

          {/* Header */}
          <div className="foodRequest-header">
            <div className="foodRequest-topbar">
              {/* No back on a QR table page: the spacer keeps the title centred */}
              <img src={Prev} alt="" className="foodRequest-back" style={{ visibility: "hidden" }} />
              {isSearching ? (
                <>
                  <input
                    type="text"
                    placeholder="Search dishes..."
                    className="searchField"
                    autoFocus
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <img
                    src={CloseIcon}
                    alt="Close search"
                    className="foodRequest-search-icon"
                    onClick={handleCloseSearch}
                  />
                </>
              ) : (
                <>
                  <div className="foodRequest-title">
                    <h2>Food Menu</h2>
                  </div>
                  <img
                    src={SearchIcon}
                    alt="Search"
                    className="foodRequest-search-icon"
                    onClick={handleSearchClick}
                  />
                </>
              )}
            </div>

            {/* Cuisine tabs */}
            {search === "" && types.length > 1 && (
              <div className="food-tabs">
                {types.map(type => (
                  <button
                    key={type}
                    className={`food-tab ${activeType === type ? 'active' : ''}`}
                    onClick={() => setActiveType(type)}
                  >
                    {titleCase(type)}
                  </button>
                ))}
              </div>
            )}

            {/* Filters */}
            <div className="food-filters">
              {DIET_FILTERS.map(filter => (
                <button
                  key={filter.key}
                  className={`food-chip ${diets.includes(filter.key) ? 'active' : ''}`}
                  onClick={() => toggleDiet(filter.key)}
                >
                  <FoodTypeMark foodType={filter.key} size={12} />
                  {filter.label}
                </button>
              ))}
              <button
                className={`food-chip ${onlyBestseller ? 'active' : ''}`}
                onClick={() => setOnlyBestseller(prev => !prev)}
              >
                ⭐ Bestseller
              </button>
              <button
                className={`food-chip ${onlyChefSpecial ? 'active' : ''}`}
                onClick={() => setOnlyChefSpecial(prev => !prev)}
              >
                👨‍🍳 Chef's Special
              </button>
              {filtersApplied && (
                <button className="food-chip food-chip-clear" onClick={clearFilters}>
                  Clear
                </button>
              )}
            </div>

          </div>

          {/* Menu */}
          <div className="food-menu">
            {groups.length === 0 && (
              <div className="food-empty">
                <p>No dishes match what you're looking for.</p>
                {filtersApplied && (
                  <button onClick={clearFilters}>Clear filters</button>
                )}
              </div>
            )}

            {groups.map(([type, items]) => (
              <div
                className="food-group"
                key={type}
                ref={(node) => { groupRefs.current[type] = node; }}
              >
                {search !== "" && (
                  <div className="food-group-head">
                    <h3>{titleCase(type)}</h3>
                    <span>{items.length}</span>
                  </div>
                )}

                {items.map((food) => (
                  <FoodCard
                    key={food.id}
                    name={food.name}
                    price={food.price}
                    desc={food.description}
                    is_bestseller={food.is_bestseller}
                    photo={food.photo && food.photo !== "" ? food.photo : Photo}
                    id={food.id}
                    foodCart={foodCart}
                    setFoodCart={setFoodCart}
                    is_chef_recommended={food.is_chef_recommended}
                    average_rating={food.average_rating}
                    number_of_ratings={food.number_of_ratings}
                    is_available={food?.is_available}
                    availability_windows={food?.availability_windows}
                    gst_percentage={food?.gst_percentage}
                    food_type={food.food_type}
                  />
                ))}
              </div>
            ))}
          </div>

          {/* Browse categories */}
          <button
            className={`food-categories-fab ${foodCart.length > 0 ? 'raised' : ''} ${menuModal ? 'open' : ''}`}
            onClick={() => setMenuModal(prev => !prev)}
          >
            <img src={menuIcon} alt="" />
            {menuModal ? "Close" : "Categories"}
          </button>

          {/* Cart — floats over the menu, only once there is something in it */}
          {foodCart.length > 0 && (
            <div className="food-cart-bar">
              <div className="food-cart-info">
                <h4>₹ {totalPrice}</h4>
                <p>{quantity} {quantity === 1 ? "item" : "items"} added</p>
              </div>
              <button className="food-cart-cta" onClick={handleConfirm}>
                Confirm Order
              </button>
            </div>
          )}

        </div>
      }

      {
        confirmPrice &&
        <div className="foodSummary">
          <div className="foodSummary-header">
            <img src={PrevIcon} alt="Error" onClick={moveBack} />
            <h3>Food Order Summary</h3>
          </div>

          <div className="foodSummary-data">
            {foodCart.map((cart,index)=>(
              <div className="foodSummary-order" key = {index}>
                  <div className="foodSummary-name">
                    <p>{cart.name} x {cart.quantity}</p>
                  </div>
                  <div className="foodSummary-price">
                    <p>{cart.price} ₹</p>
                  </div>
              </div>
            ))}
          </div>

          <PromoSection
            userId={userId}
            hotelId={hotelId}
            service="Restaurant Dining"
            orderAmount={Number(totalPrice) || 0}
            appliedPromo={appliedPromo}
            discountAmount={discountAmount}
            onApply={handleApplyPromo}
            onRemove={handleRemovePromo}
          />

          <div className="foodSummary-bill">
            <div className="foodSummary-bill-row">
                <p>Subtotal</p>
                <p>{formatMoney(totalPrice)} ₹</p>
            </div>
            {appliedPromo && (
                <div className="foodSummary-bill-row foodSummary-bill-discount">
                    <p>Discount ({appliedPromo.code})</p>
                    <p>- {formatMoney(discountAmount)} ₹</p>
                </div>
            )}
            {taxTotal > 0 && (
                <div className="foodSummary-bill-row">
                    <p>GST</p>
                    <p>+ {formatMoney(taxTotal)} ₹</p>
                </div>
            )}
            <div className="foodSummary-bill-row foodSummary-bill-total">
                <h4>Total</h4>
                <h4>{formatMoney(payableTotal)} ₹</h4>
            </div>
          </div>

          <div className='food-note'>
            <h4><span>Note :</span> {taxTotal > 0 ? 'total includes GST' : 'no GST applies to this order'}</h4>
          </div>

          <div className="foodSummary-comment">
              <div className="comment-label">
                  <h5>Comments</h5>
              </div>
              <div className="comment-input">
                  <textarea rows="10" cols="30" name="comments" value={formData.comments} onChange={handleChangeComment} />
              </div>
            
          </div>


        <div className="foodSummary-service">
          <div className="foodSummary-order">
            <div className="foodSummary-button">
              <button onClick={handleSubmit}  >Send Request</button>
            </div>
          </div>
        </div>



        </div>
      }

      {
          menuModal && (
              <MenuModal
                  setMenuModal={setMenuModal}
                  menu={menu}
                  onSelectType={scrollToType}
                  activeType={activeType}
                  raised={foodCart.length > 0}
              />
          )
      }

 
    </>
  )
}
